import {Injectable} from '@angular/core';
import {bindCallback, ConnectableObservable, Observable, of, ReplaySubject, throwError} from 'rxjs';
import {map, multicast, switchMap} from 'rxjs/operators';
import {ExgMapAPILoader} from './exg-map-api-loader.service';

@Injectable({providedIn: 'root'})
export class ExgMapDirectionsService {
  protected readonly directions$: Observable<google.maps.DirectionsService>;

  constructor(loader: ExgMapAPILoader) {
    const connectableDirections$ = new Observable(subscriber => {
      loader.load().then(() => subscriber.next());
    })
      .pipe(
        map(() => this._createDirections()),
        multicast(new ReplaySubject(1)),
      ) as ConnectableObservable<google.maps.DirectionsService>;

    connectableDirections$.connect();
    this.directions$ = connectableDirections$;
  }

  private _createDirections(): google.maps.DirectionsService {
    return new google.maps.DirectionsService();
  }

  private _getGoogleResults(directionsService: google.maps.DirectionsService, request: google.maps.DirectionsRequest):
    Observable<google.maps.DirectionsResult> {
    const directionsObservable = bindCallback(directionsService.route);
    return directionsObservable(request).pipe(
      switchMap(([response, status]) => {
        if (status === google.maps.DirectionsStatus.OK) {
          return of(response) as Observable<google.maps.DirectionsResult>;
        }
        return throwError(status);
      })
    );

  }

  public getRoute(request: google.maps.DirectionsRequest): Observable<google.maps.DirectionsResult> {
    return this.directions$.pipe(
      switchMap((directions) => this._getGoogleResults(directions, request))
    ) as Observable<google.maps.DirectionsResult>;
  }


}
